export default function removeFirstPathname(path: string | undefined | null) {
    return path?.split('/').slice(2, path?.length).join('/') ?? '/';
}
